/*
 * 设置cookie
 */
export const setCookie = (name, value, expiredays) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}

/*
 * 获取cookie
 */
export const getCookie = (name) => {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

/*
 * 删除cookie
 */
export const delCookie = (name) => {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
}

/*
 * 设置sessionStorage
 */
export const setSessionStorage = (name, val) => {
    sessionStorage.setItem(name, JSON.stringify(val));
}

/*
 * 通过参数获取sessionStorage的数据
 */
export const getSessionStorage = (name) => {
    if (sessionStorage.hasOwnProperty(name)) {
        return JSON.parse(sessionStorage.getItem(name));
    } else {
        return false;
    }
}

/*
 * 附加sessionStorage, type==true 则是整个修改，
 */
export const addSessionStorage = (name, val) => {
    if (sessionStorage.hasOwnProperty(name)) {
        let old = JSON.parse(sessionStorage.getItem(name));
        let obj = Object.assign(old, val);
        sessionStorage.setItem(name, JSON.stringify(obj));
    } else {
        sessionStorage.setItem(name, JSON.stringify(val));
    }
}

/*
 * 删除sessionStorage
 */
export const deleteSessionStorage = (name = null) => {
    if (name != null) {
        sessionStorage.removeItem(name);
    } else {
        sessionStorage.clear();
    }
}

/*
 * 设置localStorage
 */
export const setLocalStorage = (name, val) => {
    localStorage.setItem(name, JSON.stringify(val));
}

/*
 * 通过参数获取localStorage的数据
 */
export const getLocalStorage = (name) => {
    if (localStorage.hasOwnProperty(name)) {
        return JSON.parse(localStorage.getItem(name));
    } else {
        return false;
    }
}

/*
 * 附加localStorage, type==true 则是整个修改，
 */
export const addLocalStorage = (name, val) => {
    if (localStorage.hasOwnProperty(name)) {
        let old = JSON.parse(localStorage.getItem(name));
        let obj = Object.assign(old, val);
        localStorage.setItem(name, JSON.stringify(obj));
    } else {
        localStorage.setItem(name, JSON.stringify(val));
    }
}

/*
 * 删除localStorage
 */
export const deleteLocalStorage = (name = null) => {
    if (name != null) {
        localStorage.removeItem(name);
    } else {
        localStorage.clear();
    }
}

/*
 *深拷贝
 */
export const deepClone = (obj) => {
    var objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
}


/*
 *深合并
 */
export const deepMerger = (obj1, obj2) => {
    for (var key in obj2) {
        if (obj2.hasOwnProperty(key)) {
            if (obj2[key] && typeof obj2[key] === "object") {
                obj1[key] = deepMerger(obj1[key], obj2[key]);
            } else {
                obj1[key] = obj2[key];
            }
        }
    }
    return obj1;
}

/*
 *格式
 */
export const formatModel = (thisObj, sourceObj) => {
    for (var key in thisObj) {
        if (sourceObj && typeof (sourceObj[key]) != 'undefined') {
            if (thisObj[key] && Object.prototype.toString.call(thisObj[key]) === "[object Object]") {
                formatModel(thisObj[key], sourceObj[key]);
            } else {
                thisObj[key] = sourceObj[key];
            }
        }
    }
    return thisObj;
}

export const mergeJSONObjects = function (arr1, arr2) {
    // 创建一个新的对象用于存储合并后的结果
    var mergedObject = {};

    // 遍历 arr1 的键
    for (var key in arr1) {
        // 检查 arr1 是否有该键，并且该键在 arr2 中也存在
        if (arr1.hasOwnProperty(key) && arr2.hasOwnProperty(key)) {
            // 如果 arr2 中的值是对象，则递归调用 mergeJSONObjects 进行深度合并
            if (typeof arr2[key] === 'object' && typeof arr1[key] === 'object') {
                mergedObject[key] = mergeJSONObjects(arr1[key], arr2[key]);
            } else {
                // 否则，使用 arr2 中的值覆盖 arr1 中的值
                mergedObject[key] = arr2[key];
            }
        } else {
            // 如果 arr2 中没有该键，则使用 arr1 中的值
            mergedObject[key] = arr1[key];
        }
    }

    // 遍历 arr2 的键，将 arr2 中新增的键值对添加到 mergedObject 中
    for (var key in arr2) {
        if (arr2.hasOwnProperty(key) && !arr1.hasOwnProperty(key)) {
            mergedObject[key] = arr2[key];
        }
    }

    return mergedObject;
}

//重组数据给大模型翻译
export const transformJSONtoData = function (json) {
    var transformedData = [];
    json.forEach(function (item) {
        // 获取 ingredient_id 和 ingredient_name 属性的值
        // var id = item.ingredient_id;
        var name = item.ingredient_name;
        // 将 id 和 name 组成键值对，并添加到 transformedData 数组中
        // var keyValue = {};
        // keyValue[id] = name;
        transformedData.push(name);
    });
    // const transformedData = json.map(item => {
    //   const transformedItem = {};
    //   transformedItem[item.ingredient_id] = item.ingredient_name;
    //   return transformedItem;
    // });

    return transformedData;
}
//拿到翻译之后的数据重组新数据给服务端
export const transformDataForServer = function (data, app_id, product_id) {
    const transformedJson = data.map(item => {
        // const key = Object.keys(item)[0];
        // const value = item[key];
        return {
            ingredient_id: 0,
            ingredient_name: item,
            image_id: 0,
            product_id: product_id,
            app_id: app_id,
            sort: 1
        };
    });
    return transformedJson;
}
export const getAbsolutePosition = function (element, isFixedElement = false, endElement = null) {
    let left = 0;
    let top = 0;
    let scrollTop = 0;
    let scrollLeft = 0;
    let _element = element;
    while (_element) {
        // console.log(_element, _element.offsetLeft);
        left += _element.offsetLeft;
        top += _element.offsetTop;
        if (_element === endElement) {
            break
        }
        // 类型断言
        _element = _element.offsetParent;

    }
    _element = element;
    while (_element && !isFixedElement) {
        if (_element.scrollTop) {
            scrollTop += _element.scrollTop;
        }
        if (_element.scrollLeft) {
            scrollLeft += _element.scrollLeft;
        }
        if (_element === endElement) {
            break
        }
        _element = _element.parentNode;

    }
    top = top - scrollTop;
    left = left - scrollLeft;
    return {
        left: left,
        top: top,
    }
}
// 是否多语言翻译
export const checkLanguage = function (lang) {
    if (!lang) {
        return false
    }
    if (Object.prototype.toString.call(lang) === '[object Object]') {
        const category = lang.category || lang.product_info
        if (category) {
            const languageObj = JSON.parse(category)
            let isOk = true;
            for (let key in languageObj) {
                if (typeof languageObj[key] === 'string' && !languageObj[key]) {
                    isOk = false
                }
                if (Object.prototype.toString.call(languageObj[key]) === '[object Object]' && JSON.stringify(languageObj[key]) === '{}') {
                    isOk = false
                }
            }
            if (Object.keys(languageObj).length < 6) {
                isOk = false
            }
            return isOk
        }
        return false
    }
    return false
}

export const changeRoute = async (router, route, obj) => {
    let oldQuery = route.query
    let newQuery = Object.assign({}, oldQuery, obj)
    await router.push({
        query: newQuery
    })
}

export function downloadFile(url, name) {
    let urlArr = url.split("/")
    urlArr[urlArr.length - 1] = encodeURIComponent(urlArr[urlArr.length - 1])
    url = urlArr.join('/')
    const el = document.createElement("a");
    el.style.display = "none";
    el.setAttribute("target", "_blank");
    /**
     * download的属性是HTML5新增的属性
     * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
     * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
     * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
     */
    el.setAttribute("download", name);
    // console.log(
    //     `${document.location.protocol}//${document.location.hostname}:${document.location.port}/` +
    //     url
    // );
    el.href = url
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
}

// 把date格式或时间戳格式的时间转化为一般人都可以看懂的时间格式
export function formatDateToString(minimumUnit = "second", time) {
    let _time = new Date(time);
    let res = "";
    let year = _time.getFullYear();
    res += String(year);
    if (minimumUnit === "year") {
        return res;
    }

    let month = _time.getMonth() + 1;
    month = formatNum(month);
    res += "-" + month;
    if (minimumUnit === "month") {
        return res;
    }

    let date = _time.getDate();
    date = formatNum(date);
    res += "-" + date;
    if (minimumUnit === "date") {
        return res;
    }

    let hour = _time.getHours();
    hour = formatNum(hour);
    res += " " + hour;
    if (minimumUnit === "hour") {
        return res;
    }

    let minute = _time.getMinutes();
    minute = formatNum(minute);
    res += ":" + minute;
    if (minimumUnit === "minute") {
        return res;
    }

    let second = _time.getSeconds();
    second = formatNum(second);
    res += ":" + second;
    if (minimumUnit === "second") {
        return res;
    }

    return res;

    function formatNum(num) {
        return num < 10 ? `0${num}` : String(num);
    }
}

export const countryList = [{
    name: '阿尔巴尼亚',
    ids: ['AL', 'ALB'],
    code: 355
}, {
    name: '安道尔',
    ids: ['AD', 'AND'],
    code: 376
}, {
    name: '奥地利',
    ids: ['AT', 'AUT'],
    code: 43
}, {
    name: '白俄罗斯',
    ids: ['BY', 'BLR'],
    code: 375
}, {
    name: '比利时',
    ids: ['BE', 'BEL'],
    code: 32
}, {
    name: '波斯尼亚和黑塞哥维那',
    ids: ['BA', 'BIH'],
    code: 387
}, {
    name: '保加利亚',
    ids: ['BG', 'BGR'],
    code: 359
}, {
    name: '克罗地亚',
    ids: ['HR', 'HRV'],
    code: 385
}, {
    name: '塞浦路斯',
    ids: ['CY', 'CYP'],
    code: 357
}, {
    name: '捷克共和国',
    ids: ['CZ', 'CZE'],
    code: 420
}, {
    name: '丹麦',
    ids: ['DK', 'DNK'],
    code: 45
}, {
    name: '爱沙尼亚',
    ids: ['EE', 'EST'],
    code: 372
}, {
    name: '法罗群岛',
    ids: ['FO', 'FRO'],
    code: 298
}, {
    name: '芬兰',
    ids: ['FI', 'FIN'],
    code: 358
}, {
    name: '法国',
    ids: ['FR', 'FRA'],
    code: 33
}, {
    name: '格鲁吉亚',
    ids: ['GE', 'GEO'],
    code: 995
}, {
    name: '德国',
    ids: ['DE', 'DEU'],
    code: 49
}, {
    name: '直布罗陀',
    ids: ['GI', 'GIB'],
    code: 350
}, {
    name: '希腊',
    ids: ['GR', 'GRC'],
    code: 30
}, {
    name: '格陵兰',
    ids: ['GL', 'GRL'],
    code: 299
}, {
    name: '匈牙利',
    ids: ['HU', 'HUN'],
    code: 36
}, {
    name: '冰岛',
    ids: ['IS', 'ISL'],
    code: 354
}, {
    name: '爱尔兰',
    ids: ['IE', 'IRL'],
    code: 353
}, {
    name: '意大利',
    ids: ['IT', 'ITA'],
    code: 39
}, {
    name: '拉脱维亚',
    ids: ['LV', 'LVA'],
    code: 371
}, {
    name: '列支敦士登',
    ids: ['LI', 'LIE'],
    code: 423
}, {
    name: '立陶宛',
    ids: ['LT', 'LTU'],
    code: 370
}, {
    name: '卢森堡',
    ids: ['LU', 'LUX'],
    code: 352
}, {
    name: '马其顿',
    ids: ['MK', 'MKD'],
    code: 389
}, {
    name: '马耳他',
    ids: ['MT', 'MLT'],
    code: 356
}, {
    name: '摩尔多瓦',
    ids: ['MD', 'MDA'],
    code: 373
}, {
    name: '摩纳哥',
    ids: ['MC', 'MCO'],
    code: 377
}, {
    name: '黑山',
    ids: ['ME', 'MNE'],
    code: 382
}, {
    name: '荷兰',
    ids: ['NL', 'NLD'],
    code: 31
}, {
    name: '挪威',
    ids: ['NO', 'NOR'],
    code: 47
}, {
    name: '波兰',
    ids: ['PL', 'POL'],
    code: 48
}, {
    name: '葡萄牙',
    ids: ['PT', 'PRT'],
    code: 351
}, {
    name: '罗马尼亚',
    ids: ['RO', 'ROU'],
    code: 40
}, {
    name: '俄罗斯',
    ids: ['RU', 'RUS'],
    code: 7
}, {
    name: '圣马力诺',
    ids: ['SM', 'SMR'],
    code: 378
}, {
    name: '塞尔维亚',
    ids: ['RS', 'SRB'],
    code: 381
}, {
    name: '斯洛伐克',
    ids: ['SK', 'SVK'],
    code: 421
}, {
    name: '斯洛文尼亚',
    ids: ['SI', 'SVN'],
    code: 386
}, {
    name: '西班牙',
    ids: ['ES', 'ESP'],
    code: 34
}, {
    name: '瑞典',
    ids: ['SE', 'SWE'],
    code: 46
}, {
    name: '瑞士',
    ids: ['CH', 'CHE'],
    code: 41
}, {
    name: '乌克兰',
    ids: ['UA', 'UKR'],
    code: 380
}, {
    name: '英国',
    ids: ['GB', 'GBR'],
    code: 44
}, {
    name: '梵蒂冈',
    ids: ['VA', 'VAT'],
    code: 379
}]


// 字符串去空格
export const strTrim = (str) => {
    if (str.trim) {
        return str.trim()
    }
    return str.replace(/^\s*(.*?)\s*$/g, '$1')
}


// 获取唯一id
export const getUuid = (len = 36) => {
    let s = [];
    // 随机的id值从以下字符串中产生
    const uuidData = "0123456789abcdefghijklmnopqrstuvwxyz";
    const uuidDataLength = uuidData.length;
    //此处循环了len次，可以修改循环次数，循环次数决定生成id长度	
    for (let i = 0; i < len; i++) {
        // 从uuidData中随机截取一个字符
        s[i] = uuidData.substr(Math.floor(Math.random() * uuidDataLength), 1);
    }
    let uuid = s.join("");
    return uuid;
}



// WEBPACK FOOTER //
// ./src/utils/base.js